var render = function render(){var _vm=this,_c=_vm._self._c;return _c('export-date-range',{attrs:{"title":"Export Leads","export_path":"/v1/export/leads/","params":{country: _vm.country}}})
}
var staticRenderFns = []

export { render, staticRenderFns }